/**
 * Categorias de níveis educacionais
 * Baseado no sistema educacional brasileiro
 */

export const educationCategories = {
  "Pós-Graduação": [
    "Pós-Doutorado",
    "Doutorado",
    "Mestrado",
    "MBA",
    "Especialização",
    "Residência Médica"
  ],
  
  "Ensino Superior": [
    "Graduação completa",
    "Graduação em andamento",
    "Tecnólogo completo",
    "Tecnólogo em andamento",
    "Licenciatura",
    "Bacharelado"
  ],
  
  "Ensino Técnico": [
    "Técnico completo",
    "Técnico em andamento",
    "Curso profissionalizante",
    "Formação técnica"
  ],
  
  "Ensino Médio": [
    "Médio completo",
    "Médio incompleto",
    "Supletivo",
    "EJA - Ensino Médio"
  ],
  
  "Ensino Fundamental": [
    "Fundamental completo",
    "Fundamental incompleto",
    "EJA - Ensino Fundamental"
  ],
  
  "Formação Livre": [
    "Autodidata",
    "Cursos livres",
    "Cursos online",
    "Certificações profissionais",
    "Bootcamps",
    "Workshops e seminários"
  ]
};

/**
 * Opções especiais que sempre aparecem na lista
 */
export const specialEducationOptions = [
  "Outros"
];

/**
 * Type para categorias de educação
 */
export type EducationCategories = typeof educationCategories;
